import type { PropertyType } from "@estate-platform/domain/places";

// WHY: a type-only mirror of the domain enum; importing its schema would pull the Temporal polyfill into the first load.
export const propertyTypeValues = {
  primaryResidence: "primaryResidence",
  winterResidence: "winterResidence",
  summerResidence: "summerResidence",
  holiday: "holiday",
  townhouse: "townhouse",
  apartment: "apartment",
  ranch: "ranch",
  storage: "storage",
  other: "other",
} as const satisfies { readonly [Type in PropertyType]: Type };
